<template>
  <div :class="{ 'delivery-and-pickup-container' : dnpState?.isCurbsideEligible?.value }">
    <MultiSelectDefault
      ref="msdRef"
      :facet="dnpState?.facet?.value"
      :update-selected="onSelectionStateUpdate"
      :custom-value-renderer="customValueRenderer"
      :on-init="onParentInit"
    >
      <Slideout
        :id="locatorSlideoutId"
        title="Select a Store"
        class="optimazed-facets"
      >
        <Locator
          v-if="locatorSlideoutShown"
          :address="locatorData?.address"
          :type-of="locatorData?.locationType"
          :division-number="locatorData?.divisionNumber"
          :location-radius="locatorData?.locationRadius"
          :my-store-id="locatorData?.myStoreId.value"
          :results-displayed="locatorData?.resultsDisplayed"
          :page="pageType"
          :zip-code="locatorData?.zipCode?.value"
          :use-fcc-api="locatorData?.useFccApi"
          :show-accordion="locatorData?.showAccordion"
          :show-curbside-hours="locatorData?.showCurbsideHours"
          :show-avalability="locatorData?.showAvailability"
          :is-bridal="locatorData?.isBridal"
          :use-msp-locator-api="locatorData?.useMspLocatorApi"
          :search-by-zip-code="locatorData?.searchByZipCode"
          :new-google-api-call="newGoogleAPICallEnabled"
          :new-places-details-api-enabled="newPlacesDetailsApiEnabled"
          :store-in-preference-database-enabled="storeInPreferenceDatabaseEnabled"
          @storeSelected="handleStoreSelected"
          @storesFound="handleStoresFound"
          @locationError="handleLocationError"
        />
      </Slideout>
      <ZipcodeSlideout
        v-if="zipcodeSlideoutShown"
        :id="zipCodeSlideoutId"
        :zip-code="dnpState?.sddZip?.value"
        :page="pageType"
        @vue:mounted="isZipCodeButtonBusy = false"
        @update:zipCode="handleZipCodeUpdate"
      />
    </MultiSelectDefault>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ZipcodeSlideout from '@common-vue/fulfillment/src/components/zipcodeSlideout/ZipcodeSlideout';
import { Slideout } from '@atomic-ui/slideout';
import Locator from '@common-vue/locator/src/components/Locator';
import useKillSwitches from '@composables/useKillSwitches';
import MultiSelectDefault from './MultiSelectDefault';
import useDeliveryAndPickup from '../../composables/useDeliveryAndPickup';

const props = defineProps({
  facet: {
    type: Object,
    required: true,
  },
});

/* istanbul ignore next */
const msdRef = ref(null);
const { newGoogleAPICallEnabled, newPlacesDetailsApiEnabled, storeInPreferenceDatabaseEnabled } = useKillSwitches();
/* istanbul ignore next */
const {
  onParentInit,
  dnpState,
  locatorData,
  onSelectionStateUpdate,
  customValueRenderer,
  zipCodeSlideoutId,
  locatorSlideoutId,
  pageType,
  locatorSlideoutShown,
  zipcodeSlideoutShown,
  handleStoreSelected,
  handleStoresFound,
  handleLocationError,
  handleZipCodeUpdate,
} = useDeliveryAndPickup(props, msdRef);

</script>

<style scoped lang="scss">
:deep(.input-container) {
  margin-top: 0;
  margin-bottom: 0;
}

.delivery-and-pickup-container {
  margin-bottom: 14px;
}

:deep(.facet-type-DELIVERY_AND_PICKUP) {
  .checkBoxesContainer {
    overflow: visible;
    .checkbox-container {
      margin-right: 0px;
    }
  }
}

:deep(.upc-bops-value-curbside) {
  position: absolute;
  color: #626369;
}

:deep(.upc-bops-value) {
  position: relative;
  display: inline-block;
  width: 280px;
  white-space: nowrap;

  .upc-bops-value-title {
    overflow: hidden;
    text-overflow:ellipsis;
  }
}
</style>
<style lang="scss">

.optimazed-facets {
  .select-store-btn {
    @media screen and ( max-width: 1280px) {
      width: 50%;
    }

    @include breakpoint(small only) {
      width: 100%;
      margin-left: 0;
    }
  }
}

@include breakpoint(small only) {
  button#facet_DELIVERY_AND_PICKUP {
    & + .facet-dropdown-cont {
      left: 0;
      width: 100vw;

      .dropdown.opened {
        width: 100%;
        border-radius: 0;
        border-top: none;
        border-left: none;
        border-right: none;
        padding-left: 1.3rem;
      }
    }
  }
}
</style>
